import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarm,
  CPSConfigAlarmElement,
  CPSConfigCard,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';

export function P00032Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('snSAlarme') === 1) {
    if (getValue('snSEtatPile') !== 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.SENSE,
        functionalityTitle: 'dashboard.mesure',
        title: 'P00032.status.etatPile',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.SENSE,
        functionalityTitle: 'dashboard.mesure',
        title: 'P00032.status.coProduit',
      });
    }
  }

  return res;
}
